import useAppStore from "@/context/store";
import { goGdMerge } from "@/pageComponents/GdMerge";
import { isGdMerged } from "@/utils/gaoding";
import { gaodingEditHost } from "@/utils/host";
import { Dropdown } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { openBoardModal, openCreatePin } from "../../utils/open";
import HBIcon from "../HBIcon";
import { useIsNewHeader } from "./headerContext";
import styles from "./index.module.less";

// 创建画板，上传采集入口
export default function CreateEntry() {
  const { user, config } = useAppStore(({ user, config }) => ({
    user,
    config,
  }));
  const router = useRouter();
  const isNewHeader = useIsNewHeader();

  const onCreateBoard = useCallback(async () => {
    openBoardModal({
      name: "boardModal",
      onOk: (board) => {
        router.push(`/boards/${board.board_id}`);
      },
    });
  }, [router]);

  const onCreatePin = useCallback(async () => {
    openCreatePin();
  }, []);

  const onGdEdit = useCallback(() => {
    const url = `https://${gaodingEditHost}/create-design?action=open_local`;
    if (user && !isGdMerged(user)) {
      goGdMerge({
        redirectUri: url,
      });
      return;
    }
    window.open(url);
  }, [user]);

  if (isNewHeader) {
    return (
      <div data-tooltip="上传采集" data-tooltip-position="bottom">
        <div
          className={styles.createEntry}
          onClick={onCreatePin}
          data-gd-click="button_click"
          data-button-name="上传采集"
          data-resource-title="上传采集"
          data-gd-expose="resource_loc_expose"
          data-resource-type="弹窗"
        >
          <HBIcon type="add" />
        </div>
      </div>
    );
  }

  return (
    <Dropdown
      className={styles.avatar}
      getPopupContainer={(triggerNode) => triggerNode}
      // destroyPopupOnHide
      // visible={true}
      overlay={
        <div className={classNames(styles.dropDown, styles.entryList)}>
          <div
            className={styles.entryListItem}
            onClick={onCreatePin}
            data-gd-click="button_click"
            data-button-name="上传采集"
            data-resource-title="上传采集"
            data-gd-expose="resource_loc_expose"
            data-resource-type="弹窗"
          >
            <HBIcon type="upload" />
            <span>上传采集</span>
            <span className={styles.shortcuts}>N</span>
          </div>
          <div
            className={styles.entryListItem}
            onClick={onCreateBoard}
            data-gd-click="button_click"
            data-button-name="创建画板"
          >
            <HBIcon type="dashboard" />
            <span>创建画板</span>
            <span className={styles.shortcuts}>C</span>
          </div>
          <Link
            href="/about/goodies"
            data-gd-click="button_click"
            data-button-name="浏览器插件"
          >
            <a className={classNames(styles.entryListItem, styles.pluginItem)}>
              <HBIcon type="icon1" />
              <span>浏览器插件</span>
            </a>
          </Link>
          <a
            data-gdmerge-abcontrol
            className={styles.entryListItem}
            data-gd-click="button_click"
            data-button-name="源文件导入/在线设计"
            data-gd-expose="resource_loc_expose"
            data-resource-title="源文件导入/在线设计"
            data-resource-type="文字链接"
            data-resource-id={0}
            onClick={onGdEdit}
          >
            <HBIcon type="open_file" />
            <span>源文件导入/在线设计</span>
            <span className={styles.icon}>↗</span>
          </a>
        </div>
      }
      placement="bottomRight"
    >
      <div className={styles.createEntry}>
        <HBIcon type="add" />
      </div>
    </Dropdown>
  );
}
